export default class Locale_ResourceCapacity { 
	DifferentTimeResolution: string = `The request you're allocating on, has a different time resolution ([[differenttimeresolution]]), than the one currently selected!`;
	SaveCell = {
		Success: 'Cell saved',
		Fail: 'Failed saving cell'
	};
	AddMyselfToProjectButton: string = "Add myself to a project";
}